import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
// Copyright   : 2018 semantics GmbH
// Date        : $Date: 2026-01-14 17:43:36 +0100 (Wed, 14 Jan 2026) $
// Author      : Olli Powroznik, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 159808 $
// Purpose     : linkBox widget implementation
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { Actions, Sel } from 'uix/registries';
import { get, size } from 'ldash';
import { useActions, useGraphics, useSelector } from 'uix/hooks';
import log from 'uix/logging';
import { VIcon } from 'uix/graphics';
// ---Local imports
import styles from './linkBox.scss';
// ---Globals
// SAMPLE_DATA
let fakeItems = [
    {
        icon: 'title',
        label: 'Titel',
        link: ''
    },
    {
        icon: 'person',
        label: 'Titel',
        link: ''
    },
    {
        icon: 'time',
        label: 'Titel',
        link: ''
    }
];
export const LinkBox = ({ items = fakeItems })=>{
    let graphics = useGraphics([
        'web'
    ]);
    let i18n = useSelector(Sel.i18n);
    items = items.map(({ icon, label }, i)=>{
        let img = graphics.web ? /*#__PURE__*/ _jsx("img", {
            src: graphics.web[icon]
        }) : null;
        //map with VL-fonts
        icon == 'title' && (icon = 'box');
        icon == 'places' && (icon = 'globe');
        icon == 'person' && (icon = 'fingerprint');
        icon == 'time' && (icon = 'search');
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.tab,
            children: [
                /*#__PURE__*/ _jsx(VIcon, {
                    className: styles.icon,
                    name: icon,
                    style: {
                        color: 'white',
                        fontSize: '2rem'
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.label,
                    children: i18n.get(label)
                })
            ]
        }, i);
    });
    return /*#__PURE__*/ _jsx("div", {
        className: styles.flexContainer,
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.linkBox,
            children: items
        })
    });
};
